import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
    providedIn: "root"
})
export class ServiceDetailService {

  private serviceDetailSource = new BehaviorSubject("Service Name");
  currentMessage = this.serviceDetailSource.asObservable();

  setServiceDetailData(message: string): void {
      this.serviceDetailSource.next(message);
  }
}
